





































































































































































import { Component, Vue } from 'vue-property-decorator';

import StepConfigureContributionsWealthViewModel
  from '@/vue-app/view-models/components/flagship/flagship-link-goals/steps-wealth/step-configure-contributions-wealth-view-model';

@Component({
  name: 'StepConfigureContributionsWealth',
  components: {
    CustomTooltip: () => import('@/vue-app/components/custom/CustomTooltip.vue'),
  },
})
export default class StepConfigureContributionsWealth extends Vue {
  view_model = Vue.observable(
    new StepConfigureContributionsWealthViewModel(this),
  );

  created() {
    this.view_model.initialize();
  }
}
